/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Grower_Area_Public_View_GrowerInputs */

const vi_grower_area_public_view_grower = /** @type {(inputs: Grower_Area_Public_View_GrowerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Xem chi tiết hộ`)
};

/**

* @param {Grower_Area_Public_View_GrowerInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const grower_area_public_view_grower = /** @type {((inputs?: Grower_Area_Public_View_GrowerInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Grower_Area_Public_View_GrowerInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_grower_area_public_view_grower(inputs)
});